export const RULE = {
  EMAIL: /^(?![-_.+])([a-zA-Z0-9-_.+](?![-_.+]{2,}))+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/,
  NUMBER: /[^0-9]/g,
  STRING: /^[a-zA-Z0-9\s]/g,
  NUMBER_OR_FLOAT: /^[0-9]*\.?[0-9]/g,
  DATE: /^[0-9/]+$/,
  JAPANESE: /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤]/,
  PASSWORD: /(?=(.*[0-9]))(?=.*[!@#$%^&*(){}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,16}/,
};
